import { render } from "./ChatRoomView.vue?vue&type=template&id=f071b006&scoped=true"
import script from "./ChatRoomView.vue?vue&type=script&lang=js"
export * from "./ChatRoomView.vue?vue&type=script&lang=js"

import "./ChatRoomView.vue?vue&type=style&index=0&id=f071b006&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f071b006"

export default script